import React from 'react';
import { ContextWidget } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { TeamRoomMemberRequestsListBlock } from '../../_blocks/TeamRoomMemberRequestsList';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { DefaultContextWidget } from '../_utils/asDefaultWidget';

export type TeamRoomMemberRequestListWidget = ContextWidget<
  TeamRoomMemberRequestsListBlock,
  WidgetType.teamroommemberrequestslist
>;

export function TeamRoomMemberRequestListWidget(props: TeamRoomMemberRequestListWidget) {
  const { t } = useSonTranslation('TeamRoomMemberRequests');
  return <DefaultContextWidget icon={Icons.ENTER_TEAMROOM_ARROW} title={t('widgetTitle')} {...props} />;
}
